import React from 'react';

import classnames from 'classnames';
import { Add, DeleteOutline, ArrowForward } from '@material-ui/icons';

import { useWishlist } from '../../context/WishlistContext';

import './styles.scss';

const CATEGORY_LABELS = {
  outfit: 'Outfit',
  backpack: 'Back Bling',
  pickaxe: 'Pickaxe',
  emote: 'Emote',
  glider: 'Glider',
  wrap: 'Wrap',
  contrail: 'Contrail',
  loadingscreen: 'Loading Screen',
  shoe: 'Kicks',
  sidekick: 'Sidekick',
  emotes: 'Emote',
};

function getCategoryLabel(item) {
  return CATEGORY_LABELS[item.category] || CATEGORY_LABELS[item.section] || 'Item';
}

const EMPTY_SLOTS = 3;

export default function WishlistSidebar({ onViewFull, onAddMore }) {
  const { wishlist, removeFromWishlist } = useWishlist();

  return (
    <aside className="wishlist-sidebar">
      <div className="wishlist-sidebar-header">
        <h2 className="wishlist-sidebar-title">MY WISHLIST</h2>
        {wishlist.length > 0 && (
          <span className="wishlist-sidebar-count">{wishlist.length}</span>
        )}
      </div>

      <div className="wishlist-sidebar-items">
        {wishlist.map((item) => (
          <div key={item.id} className="wishlist-sidebar-item">
            <div className={classnames('wishlist-sidebar-thumb', item.rarity, {
              emote: item.category === 'emotes' || item.section === 'emote',
            })}>
              <img src={item.imageUrl} alt={item.name} />
            </div>
            <div className="wishlist-sidebar-details">
              <p className="wishlist-sidebar-name">{item.name}</p>
              <p className="wishlist-sidebar-category">{getCategoryLabel(item)}</p>
              {(item.vBucks || item.price) && (
                <p className="wishlist-sidebar-price">
                  <img src="/assets/icons/vBuck.png" alt="" />
                  {item.vBucks || item.price}
                </p>
              )}
            </div>
            <button
              type="button"
              className="wishlist-sidebar-remove"
              onClick={() => removeFromWishlist(item)}
              aria-label={`Remove ${item.name}`}
            >
              <DeleteOutline />
            </button>
          </div>
        ))}

        {Array.from({ length: Math.max(0, EMPTY_SLOTS - wishlist.length) }).map((_, i) => (
          <button
            key={`empty-${i}`}
            type="button"
            className="wishlist-sidebar-empty"
            onClick={onAddMore}
          >
            <Add />
            <span>ADD MORE ITEMS</span>
          </button>
        ))}
      </div>

      <button type="button" className="wishlist-sidebar-view-all" onClick={onViewFull}>
        VIEW FULL WISHLIST
        <ArrowForward />
      </button>
    </aside>
  );
}
